module.exports = __webpack_public_path__ + "img/Osasuna.219b8023.png";